import { cn } from "@/lib/utils";
import { ControllerRenderProps, FieldPath, FieldValues } from "react-hook-form";

type Props<
  TFieldValues extends FieldValues,
  TFieldName extends FieldPath<TFieldValues>,
> = {
  label?: string;
  icon?: React.ReactNode;
  error?: string;
  "data-sentry-unmask"?: boolean;
  autoComplete?: string;
  type?: string;
  autoFocus?: true;
} & ControllerRenderProps<TFieldValues, TFieldName>;

export function InputFormField<
  TFieldValues extends FieldValues,
  TFieldName extends FieldPath<TFieldValues>,
>({ autoFocus, ...props }: Props<TFieldValues, TFieldName>) {
  return (
    <div className="form-group">
      <div className={cn("input-group", props.disabled && "disabled")}>
        {props.label && <label htmlFor={props.name}>{props.label}</label>}
        <span className="icon-container">{props.icon}</span>
        <input
          {...props}
          value={props.value ?? ""}
          data-sentry-unmask={props["data-sentry-unmask"]}
          id={props.name}
          autoComplete={props.autoComplete}
          type={props.type ?? "text"}
          autoFocus={autoFocus}
        />
      </div>
      <span className="form-error">{props.error}</span>
    </div>
  );
}
